<script setup lang="ts">
  import { Text, Button } from "@ui-kit";
  import { StatusBar } from "@src/components";
  import { useTimer } from "@src/hooks";

  const emit = defineEmits<{ "click:again": [value: void]; "close": [value: void] }>();

  const { timer } = useTimer(3, () => emit("click:again"));
</script>

<template>
  <div class="quarantine" data-testid="quarantine">
    <StatusBar />
    <div class="content">
      <IconQuarantine />
      <div class="text-block">
        <Text font="heading-H4">{{ $t("Отнесите товар в карантин") }}</Text>
        <Text color="secondary">{{ $t("Пара некорректна, отнесите вещь в карантин") }}</Text>
      </div>
    </div>
    <div class="footer">
      <Button variant="secondary" @click="emit('click:again')" data-testid="quarantine-again-btn">{{
        $t("Проверить ещё") + " (" + timer + ")"
      }}</Button>
      <Button @click="emit('close')" data-testid="quarantine-to-main-btn">{{ $t("На главную") }}</Button>
    </div>
  </div>
</template>

<style scoped>
  .quarantine {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    z-index: 1;
    justify-content: space-between;
    flex: 1;
    background-color: var(--sf-base-background-white);
  }

  .quarantine .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 16px;
    gap: 24px;
  }

  .quarantine .content .text-block {
    display: flex;
    flex-direction: column;
    text-align: center;
    gap: 8px;
  }

  .quarantine .footer {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px 20px;
  }

  .quarantine .footer button {
    width: 100%;
  }
</style>
